import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Clock } from 'lucide-react';
export function CTASection() {
  return <section id="checkout" className="bg-navy-900 py-24 relative overflow-hidden" data-id="element-11">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-12"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-white mb-8" data-id="element-15">
            Your Peace of Mind Can't Wait
          </h2>

          <p className="text-xl text-cream-warm/80 mb-12 max-w-2xl mx-auto" data-id="element-16">
            Join hundreds of women who have already built their own emotional
            and financial safety net.
          </p>

          <div className="bg-navy-800/80 border border-gold/30 p-8 sm:p-12 rounded-2xl shadow-2xl backdrop-blur-sm max-w-2xl mx-auto" data-id="element-17">
            <div className="text-gold font-bold text-2xl mb-2" data-id="element-18">
              SPECIAL OFFER
            </div>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-19">
              <span className="text-3xl text-cream-warm/50 line-through" data-id="element-20">
                $42.00
              </span>
              <span className="text-6xl font-serif font-bold text-white" data-id="element-21">
                $6.39
              </span>
            </div>

            <motion.div whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="mb-8" data-id="element-22">
              <a href="https://vivoligero.com/cart/47382103359628:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_name: 'The Secure Woman',
                  content_type: 'product',
                  value: 6.39,
                  currency: 'USD'
                });
              }
            }} className="block w-full bg-gold hover:bg-gold-bright text-navy-900 font-bold text-xl py-5 px-8 rounded-lg shadow-[0_0_30px_rgba(201,169,110,0.3)] transition-all duration-300 uppercase tracking-wide text-center" data-id="element-23">
                Yes, I Want Instant Access
              </a>
            </motion.div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm text-cream-warm/70" data-id="element-24">
              <div className="flex flex-col items-center gap-2" data-id="element-25">
                <ShieldCheck className="w-6 h-6 text-gold" data-id="element-26" />
                <span data-id="element-27">Secure One-Time Payment</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-28">
                <Clock className="w-6 h-6 text-gold" data-id="element-29" />
                <span data-id="element-30">Lifetime Access</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-31">
                <Download className="w-6 h-6 text-gold" data-id="element-32" />
                <span data-id="element-33">Instant Download</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}